(ns minorodata.webhooks.model
  (:require [mold.core :as m :refer-macros [defmodel]]))

(declare ->webhook-trigger ->webhook)

(defmodel webhook-trigger
  {:trigger-id  [::m/identity ::m/string]
   :client-id   [::m/string]
   :hook-id     [::m/string ::m/nilable]
   :action-type [::m/string]
   :params      [::m/map]})


(defmodel webhook
  {:hook-id          [::m/identity ::m/string]
   :source-master-id [::m/string]
   :source-type      [::m/string]
   :event-type       [::m/string]
   :triggers         [::m/vector]})
